import React, { useState } from 'react'
import HtmlText from "../../shared/html-text/HtmlText";

const OnlyViewApplicant = ({ htmlContent }) => {
  return (
    <React.Fragment>
      <span>
        <HtmlText htmlText={htmlContent}/>
      </span>
    </React.Fragment>
  )

}

export default OnlyViewApplicant